/* HUENIT LAB 2.0 — Admin 셸: 사이드바 nav · 라우팅 · 인증 게이트.
   ★ S1 완결 파일 — S2~S4 는 이 파일을 수정하지 않는다(신규 feature 까지 미리 연결).
   feature 추가/내용은 각 src/features/* 디렉토리에서. */
import { useSession } from './auth/session.jsx';
import { useLocal } from './data/store.js';
import { Icon } from './icons/Icon.jsx';

import { LoginScreen } from './features/auth/LoginScreen.jsx';
import { Dashboard } from './features/dashboard/Dashboard.jsx';
import { ExamplesAdmin } from './features/examples/ExamplesAdmin.jsx';
import { ExamplesAiAdmin } from './features/examples-ai/ExamplesAiAdmin.jsx';
import { ExamplesEngraveAdmin } from './features/examples-engrave/ExamplesEngraveAdmin.jsx';
import { TaxonomyAdmin } from './features/taxonomy/TaxonomyAdmin.jsx';
import { GuideAdmin } from './features/guide/GuideAdmin.jsx';
import { VersionsAdmin } from './features/versions/VersionsAdmin.jsx';
import { InstallStatsAdmin } from './features/install-stats/InstallStatsAdmin.jsx';
import { UsersAdmin } from './features/users/UsersAdmin.jsx';
import { TeacherRequestsAdmin } from './features/teacher-requests/TeacherRequestsAdmin.jsx';
import { SharesAdmin } from './features/shares/SharesAdmin.jsx';
import { LanguagesAdmin } from './features/languages/LanguagesAdmin.jsx';

const NAV = [
  { group: '콘텐츠' },
  { id: 'dashboard',        label: '대시보드',       icon: 'fit' },
  { id: 'examples',         label: '코드 예제',      icon: 'folder' },
  { id: 'examples-ai',      label: 'AI 예제',        icon: 'ai' },
  { id: 'examples-engrave', label: '그림·툴패스 예제', icon: 'image' },
  { id: 'taxonomy',         label: '예제 분류',      icon: 'blocks' },
  { id: 'guide',            label: '가이드 관리',    icon: 'guide' },
  { group: '배포' },
  { id: 'versions',         label: '버전 관리',      icon: 'storage' },
  { id: 'install-stats',    label: '설치 통계',      icon: 'chart' },
  { group: '사용자' },
  { id: 'users',            label: '사용자 관리',    icon: 'user' },
  { id: 'teacher-requests', label: '선생님 등록 요청', icon: 'bell' },
  { id: 'shares',           label: '공유 관리',      icon: 'open' },
  { group: '설정' },
  { id: 'languages',        label: '언어 설정',      icon: 'globe' },
];

const TITLES = {
  dashboard:          { t: '대시보드',        s: '콘텐츠 현황을 한눈에 확인합니다.' },
  examples:           { t: '코드 예제',       s: '블록 코딩·Python 예제를 등록·수정하고 코드 파일을 업로드합니다.' },
  'examples-ai':      { t: 'AI 예제',         s: 'AI 학습 모델 예제(.kfpkg)를 S3 에 등록·관리합니다.' },
  'examples-engrave': { t: '그림·툴패스 예제', s: '드로잉·레이저 탭에서 쓸 그림 원본과 툴패스 프로젝트를 등록합니다.' },
  taxonomy:           { t: '예제 분류',       s: '예제 카테고리와 필터 태그를 관리합니다.' },
  guide:              { t: '가이드 관리',     s: '카테고리 · 큰 주제 · 작은 주제를 구성합니다.' },
  versions:           { t: '버전 관리',       s: '앱 설치파일·펌웨어 버전을 열람·삭제하고 latest 를 변경합니다.' },
  'install-stats':    { t: '설치 통계',       s: '버전별 설치파일 다운로드 수와 가장 최근 설치 시도 시각을 확인합니다.' },
  users:              { t: '사용자 관리',     s: '회원 등급을 변경하고 탈퇴를 처리합니다.' },
  'teacher-requests': { t: '선생님 등록 요청', s: '선생님 권한 요청을 승인하거나 거절합니다.' },
  shares:             { t: '공유 관리',       s: '사용자가 공개 공유한 코드를 확인하고 수정·삭제합니다.' },
  languages:          { t: '언어 설정',       s: '콘텐츠에 사용할 지원 언어를 관리합니다.' },
};

function Section({ section, go }) {
  switch (section) {
    case 'dashboard':        return <Dashboard go={go} />;
    case 'examples':         return <ExamplesAdmin />;
    case 'examples-ai':      return <ExamplesAiAdmin />;
    case 'examples-engrave': return <ExamplesEngraveAdmin />;
    case 'taxonomy':         return <TaxonomyAdmin />;
    case 'guide':            return <GuideAdmin />;
    case 'versions':         return <VersionsAdmin />;
    case 'install-stats':    return <InstallStatsAdmin />;
    case 'users':            return <UsersAdmin />;
    case 'teacher-requests': return <TeacherRequestsAdmin />;
    case 'shares':           return <SharesAdmin />;
    case 'languages':        return <LanguagesAdmin />;
    default:                 return <Dashboard go={go} />;
  }
}

export default function App() {
  const { ready, mode, email, logout } = useSession();
  const [section, setSection] = useLocal('adm.section', 'dashboard');

  // 부트스트랩 대기
  if (!ready) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', color: 'var(--ink-400)', fontSize: 14, fontWeight: 600 }}>
        불러오는 중…
      </div>
    );
  }

  // 미로그인 → 로그인 화면만 (다른 콘텐츠 비노출 · plan §4.1)
  if (!email) return <LoginScreen />;

  const title = TITLES[section] || TITLES.dashboard;

  return (
    <div className="adm">
      <aside className="adm-side">
        <div className="adm-side__brand">
          <div className="adm-side__logo">H</div>
          <div>
            <div className="adm-side__name">HUENIT LAB</div>
            <div className="adm-side__role">CMS · 관리자</div>
          </div>
        </div>
        <nav className="adm-side__nav">
          {NAV.map((n, i) => n.group
            ? <div key={'g' + i} className="adm-side__group">{n.group}</div>
            : (
              <button key={n.id} className={"adm-nav" + (section === n.id ? " is-on" : "")} onClick={() => setSection(n.id)}>
                <Icon name={n.icon} size={18} />{n.label}
              </button>
            ))}
        </nav>
        <div className="adm-side__foot" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
            <Icon name="user" size={14} />
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{email}</span>
          </div>
          <button className="btn btn--ghost btn--sm" onClick={logout} style={{ justifyContent: 'center' }}>
            <Icon name="login" size={14} />로그아웃
          </button>
        </div>
      </aside>

      <main className="adm-main">
        <div className="adm-top">
          <div className="adm-top__titles">
            <div className="adm-top__title">{title.t}</div>
            <div className="adm-top__sub">{title.s}</div>
          </div>
          <div className="adm-top__spacer" />
          {mode === 'fake' && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '7px 12px', borderRadius: 999, background: 'var(--brand-50)', border: '1px solid var(--brand-100)', color: 'var(--brand-700)', fontSize: 12, fontWeight: 700 }}>
              <Icon name="unlock" size={14} />오프라인(데모) 모드
            </span>
          )}
        </div>
        <div className="adm-body">
          <Section section={section} go={setSection} />
        </div>
      </main>
    </div>
  );
}
